import { render, staticRenderFns } from "./DesignationSetting.vue?vue&type=template&id=42c0469a&scoped=true&"
import script from "./DesignationSetting.vue?vue&type=script&lang=js&"
export * from "./DesignationSetting.vue?vue&type=script&lang=js&"
import style0 from "./DesignationSetting.vue?vue&type=style&index=0&id=42c0469a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c0469a",
  null
  
)

export default component.exports